import * as React from "react";
import type { SVGProps } from "react";
const SvgAcademy = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
        <path
            fill="currentColor"
            d="m11.25 4.5 9.95 4.336c.183.082.3.262.3.46v3.333a1.504 1.504 0 0 1 .773 2.207l.665 4.52h-4.036l.817-4.528a1.504 1.504 0 0 1 .781-2.2v-2.57l-2.5 1.09v3.786c0 1.152-.926 2.058-2.105 2.648-1.215.605-2.86.965-4.645.965s-3.43-.36-4.645-.965c-1.18-.59-2.105-1.496-2.105-2.648v-1.887c0-.277.223-.5.5-.5s.5.223.5.5v1.887c0 .566.473 1.214 1.555 1.754 1.047.519 2.527.859 4.195.859s3.148-.34 4.195-.86C16.527 16.148 17 15.5 17 14.935v-3.348l-5.75 2.504L1.3 9.754a.5.5 0 0 1-.3-.457c0-.2.117-.379.3-.461Zm6.063 5.86a.1.1 0 0 0-.024.007L11.25 13l-8.5-3.703 8.5-3.707 8.5 3.707Zm3.312 4.019s0-.004-.004-.004a.5.5 0 0 1-.121-.328c0-.277.223-.5.5-.5a.498.498 0 0 1 .375.828v.004a.5.5 0 0 1-.375.168.5.5 0 0 1-.375-.168m-.008 1.117-.52 2.86h1.68L21.36 15.5a1.4 1.4 0 0 1-.359.047c-.133 0-.262-.02-.383-.05m0 0"
            style={{
                stroke: "none",
                fillRule: "evenodd",
                fillOpacity: 1,
            }}
        />
    </svg>
);
export default SvgAcademy;
